var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"mainContainer",staticClass:"g-layout"},[_c('ic-header',{attrs:{"menu-list":_vm.menuList}}),(_vm.loaded)?_c('div',{staticClass:"g-layout-main"},[_c('router-view')],1):_vm._e(),_c('ic-tool'),_c('portal-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }